import { SigninAuthenticationModel } from "@factory/model/query-model-authentication";
import { CreateTenantModel } from "@factory/model/query-model-tenant";
import { UpdateTenantModel } from "@factory/model/query-model-tenant";
import { DeleteTenantModel } from "@factory/model/query-model-tenant";
import { CreateRoleModel } from "@factory/model/query-model-role";
import { UpdateRoleModel } from "@factory/model/query-model-role";
import { DeleteRoleModel } from "@factory/model/query-model-role";
import {
  CreatePersonModel,
  CreatePersonModelExtension,
  UpdatePersonModelExtension,
} from "@factory/model/query-model-person";
import { UpdatePersonModel } from "@factory/model/query-model-person";
import { DeletePersonModel } from "@factory/model/query-model-person";
import {
  CreatePatientModel,
  CreatePatientModelExtension,
} from "@factory/model/query-model-patient";
import { UpdatePatientModel } from "@factory/model/query-model-patient";
import { DeletePatientModel } from "@factory/model/query-model-patient";
import {
  CreateUtilServiceModel,
  GetPublicUtilServiceModel,
} from "@factory/model/query-model-util-service";
import { UpdateUtilServiceModel } from "@factory/model/query-model-util-service";
import { DeleteUtilServiceModel } from "@factory/model/query-model-util-service";

import {
  CreateContractModel,
  CreateContractModelExtension,
  UpdateContractModelExtension,
} from "@factory/model/query-model-contract";
import { UpdateContractModel } from "@factory/model/query-model-contract";
import { DeleteContractModel } from "@factory/model/query-model-contract";
import { CreateBillingModel } from "@factory/model/query-model-billing";
import { UpdateBillingModel } from "@factory/model/query-model-billing";
import { DeleteBillingModel } from "@factory/model/query-model-billing";

import { CreateProviderTypeModel } from "@factory/model/query-model-provider-type";
import { UpdateProviderTypeModel } from "@factory/model/query-model-provider-type";
import { DeleteProviderTypeModel } from "@factory/model/query-model-provider-type";
import {
  CreateBulkPaymentModel,
  CreateBulkPaymentModelExtension,
  CreatePaymentModel,
  CreatePaymentModelExtension,
  UpdatePaymentModelExtension,
} from "@factory/model/query-model-payment";
import { UpdatePaymentModel } from "@factory/model/query-model-payment";
import { DeletePaymentModel } from "@factory/model/query-model-payment";
import {
  CreateVisitModel,
  CreateVisitModelExtension,
  UpdateVisitModelExtension,
} from "@factory/model/query-model-visit";
import { UpdateVisitModel } from "@factory/model/query-model-visit";
import { DeleteVisitModel } from "@factory/model/query-model-visit";
import { CreateWaiverModel } from "@factory/model/query-model-waiver";
import { UpdateWaiverModel } from "@factory/model/query-model-waiver";
import { DeleteWaiverModel } from "@factory/model/query-model-waiver";
import {
  ApproveRegistrationModel,
  CreateRegistrationModel,
} from "@factory/model/query-model-registration";
import { UpdateRegistrationModel } from "@factory/model/query-model-registration";
import { DeleteRegistrationModel } from "@factory/model/query-model-registration";
// MAPPER QUERY MODEL IMPORT

import {
  LoginFormSchema,
  TenantFormSchema,
  RoleFormSchema,
  PersonFormSchema,
  PatientFormSchema,
  UtilServiceFormSchema,
  ContractFormSchema,
  BillingFormSchema,
  ProviderTypeFormSchema,
  PaymentFormSchema,
  VisitFormSchema,
  WaiverFormSchema,
  RegistrationFormSchema,
  UtilServicePublicFormSchema,
  ApproveRegistrationFormSchema,
  // MAPPER IMPORT
} from "../form/form.rule";
import { useDateTimeContext } from "@shared/utility/date-time-service/date-time.context";

export function useFormApiMapper() {
  const { formatDate } = useDateTimeContext();

  const mapLogin = (form: LoginFormSchema) => {
    const payload = {
      username: form.username,
      password: form.password,
    } as SigninAuthenticationModel;

    return payload;
  };

  const mapCreateTenant = (form: TenantFormSchema) => {
    const payload = {
      owner: form.owner,
      business_name: form.businessName,
      business_type: form.businessType,
      description: form.description,
      avatar: form.avatar,
      email: form.email,
      mobile_number: form.mobileNumber,
      phone_number: form.phoneNumber,
      website: form.website,
      membership_date: formatDate(form.membershipDate as Date, undefined),
      rewards_type: form.rewardsType,
      slug: form.slug,
      post_registration_link: form.postRegistrationLink,
    } as CreateTenantModel;

    return payload;
  };
  const mapUpdateTenant = (form: TenantFormSchema, code: string) => {
    const payload = {
      code,
      owner: form.owner,
      business_name: form.businessName,
      business_type: form.businessType,
      description: form.description,
      avatar: form.avatar,
      email: form.email,
      mobile_number: form.mobileNumber,
      phone_number: form.phoneNumber,
      website: form.website,
      membership_date: formatDate(form.membershipDate as Date, undefined),
      rewards_type: form.rewardsType,
      slug: form.slug,
      post_registration_link: form.postRegistrationLink,
    } as UpdateTenantModel;

    return payload;
  };
  const mapDeleteTenant = (code: string) => {
    const payload = {
      code,
    } as DeleteTenantModel;

    return payload;
  };
  const mapCreateRole = (form: RoleFormSchema) => {
    const payload = {
      name: form.name,
      description: form.description,
    } as CreateRoleModel;

    return payload;
  };
  const mapUpdateRole = (form: RoleFormSchema, code: string) => {
    const payload = {
      code,
      name: form.name,
      description: form.description,
    } as UpdateRoleModel;

    return payload;
  };
  const mapDeleteRole = (code: string) => {
    const payload = {
      code,
    } as DeleteRoleModel;

    return payload;
  };
  const mapCreatePerson = (form: PersonFormSchema) => {
    const payload = {
      tenant: form.tenant,
      role: form.role,
      first_name: form.firstName,
      middle_name: form.middleName,
      last_name: form.lastName,
      username: form.username,
      email: form.email,
      password: form.password,
      is_verified: form.isVerified,
      avatar: form.avatar,
      activation_code: form.activationCode,
      gender: form.gender,
      birthday: formatDate(form.birthday as Date, undefined),
      is_blocked: form.isBlocked,
      mobile_number: form.mobileNumber,
      father_name: form.fatherName,
      mother_name: form.motherName,
      emergency_contact_1_number: form.emergencyContact_1Number,
      emergency_contact_1_name: form.emergencyContact_1Name,
      emergency_contact_1_relationship: form.emergencyContact_1Relationship,
      emergency_contact_2_number: form.emergencyContact_2Number,
      emergency_contact_2_name: form.emergencyContact_2Name,
      emergency_contact_2_relationship: form.emergencyContact_2Relationship,
      sss: form.sss,
      philhealth: form.philhealth,
      pagibig: form.pagibig,
      tin: form.tin,
      medical_condition: form.medicalCondition,
      blood_type: form.bloodType,
      elementary: form.elementary,
      high_school: form.highSchool,
      college: form.college,
      post_college: form.postCollege,
      undergraduate: form.undergraduate,
      curriculum_vitae: form.curriculumVitae,
      supporting_doc: form.supportingDoc,
      intent_letter: form.intentLetter,
      application_letter: form.applicationLetter,
    } as CreatePersonModel;

    const newPayload = {
      person: payload,
      file: form.photo,
    } as CreatePersonModelExtension;

    return newPayload;
  };
  const mapUpdatePerson = (form: PersonFormSchema, code: string) => {
    const payload = {
      code,
      tenant: form.tenant,
      role: form.role,
      first_name: form.firstName,
      middle_name: form.middleName,
      last_name: form.lastName,
      username: form.username,
      email: form.email,
      is_verified: form.isVerified,
      avatar: form.avatar,
      activation_code: form.activationCode,
      gender: form.gender,
      birthday: formatDate(form.birthday as Date, undefined),
      is_blocked: form.isBlocked,
      mobile_number: form.mobileNumber,
      father_name: form.fatherName,
      mother_name: form.motherName,
      emergency_contact_1_number: form.emergencyContact_1Number,
      emergency_contact_1_name: form.emergencyContact_1Name,
      emergency_contact_1_relationship: form.emergencyContact_1Relationship,
      emergency_contact_2_number: form.emergencyContact_2Number,
      emergency_contact_2_name: form.emergencyContact_2Name,
      emergency_contact_2_relationship: form.emergencyContact_2Relationship,
      sss: form.sss,
      philhealth: form.philhealth,
      pagibig: form.pagibig,
      tin: form.tin,
      medical_condition: form.medicalCondition,
      blood_type: form.bloodType,
      elementary: form.elementary,
      high_school: form.highSchool,
      college: form.college,
      post_college: form.postCollege,
      undergraduate: form.undergraduate,
      curriculum_vitae: form.curriculumVitae,
      supporting_doc: form.supportingDoc,
      intent_letter: form.intentLetter,
      application_letter: form.applicationLetter,
    } as UpdatePersonModel;

    if (form.password) {
      payload.password = form.password;
    }

    const newPayload = {
      person: payload,
      file: form.photo,
    } as UpdatePersonModelExtension;

    return newPayload;
  };
  const mapDeletePerson = (code: string) => {
    const payload = {
      code,
    } as DeletePersonModel;

    return payload;
  };
  const mapCreatePatient = (form: PatientFormSchema) => {
    const payload = {
      tenant: form.tenant,
      first_name: form.firstName,
      middle_name: form.middleName,
      last_name: form.lastName,
      birthday: form.birthday,
      gender: form.gender,
      address: form.address,
      email: form.email,
      mobile_number: form.mobileNumber,
      is_taking_medication: form.isTakingMedication,
      medication_details: form.medicationDetails,
      has_allergies: form.hasAllergies,
      allergy_details: form.allergyDetails,
      has_medical_conditions: form.hasMedicalConditions,
      medical_conditon_details: form.medicalConditionDetails,
      was_recently_unwell: form.wasRecentlyUnwell,
      unwell_details: form.unwellDetails,
      other_medical_conditions: form.otherMedicalConditions,
    } as CreatePatientModel;

    const newPayload = {
      patient: payload,
      file: form.photo,
    } as CreatePatientModelExtension;

    return newPayload;
  };
  const mapUpdatePatient = (form: PatientFormSchema, code: string) => {
    const payload = {
      code,
      first_name: form.firstName,
      middle_name: form.middleName,
      last_name: form.lastName,
      birthday: form.birthday,
      gender: form.gender,
      address: form.address,
      email: form.email,
      mobile_number: form.mobileNumber,
      is_taking_medication: form.isTakingMedication,
      medication_details: form.medicationDetails,
      has_allergies: form.hasAllergies,
      allergy_details: form.allergyDetails,
      has_medical_conditions: form.hasMedicalConditions,
      medical_conditon_details: form.medicalConditionDetails,
      was_recently_unwell: form.wasRecentlyUnwell,
      unwell_details: form.unwellDetails,
      other_medical_conditions: form.otherMedicalConditions,
    } as UpdatePatientModel;

    const newPayload = {
      patient: payload,
      file: form.photo,
    } as CreatePatientModelExtension;

    return newPayload;
  };
  const mapDeletePatient = (code: string) => {
    const payload = {
      code,
    } as DeletePatientModel;

    return payload;
  };
  const mapCreateUtilService = (form: UtilServiceFormSchema) => {
    const payload = {
      tenant: form.tenant,
      name: form.name,
      description: form.description,
      amount: form.amount,
    } as CreateUtilServiceModel;

    return payload;
  };
  const mapUpdateUtilService = (form: UtilServiceFormSchema, code: string) => {
    const payload = {
      code,
      tenant: form.tenant,
      name: form.name,
      description: form.description,
      amount: form.amount,
    } as UpdateUtilServiceModel;

    return payload;
  };
  const mapDeleteUtilService = (code: string) => {
    const payload = {
      code,
    } as DeleteUtilServiceModel;

    return payload;
  };

  const mapGetPublicUtilService = (form: UtilServicePublicFormSchema) => {
    const payload = {
      tenant: form.tenant,
    } as GetPublicUtilServiceModel;

    return payload;
  };

  const mapCreateContract = (form: ContractFormSchema) => {
    const payload = {
      tenant: form.tenant,
      patient: form.patient,
      service: form.service,
      signature: form.signature,
      amount: form.amount,
      person: form.person,
      waiver: form.waiver,
    } as CreateContractModel;

    const newPayload = {
      contract: payload,
      file: form.file,
    } as CreateContractModelExtension;

    return newPayload;
  };
  const mapUpdateContract = (form: ContractFormSchema, code: string) => {
    const payload = {
      code,
      tenant: form.tenant,
      patient: form.patient,
      service: form.service,
      signature: form.signature,
      amount: form.amount,
      person: form.person,
      waiver: form.waiver,
    } as UpdateContractModel;

    const newPayload = {
      contract: payload,
      file: form.file,
    } as UpdateContractModelExtension;

    return newPayload;
  };
  const mapDeleteContract = (code: string) => {
    const payload = {
      code,
    } as DeleteContractModel;

    return payload;
  };
  const mapCreateBilling = (form: BillingFormSchema) => {
    const payload = {
      contract: form.contract,
      session: form.session,
    } as CreateBillingModel;

    return payload;
  };
  const mapUpdateBilling = (form: BillingFormSchema, code: string) => {
    const payload = {
      code,
      contract: form.contract,
      session: form.session,
    } as UpdateBillingModel;

    return payload;
  };
  const mapDeleteBilling = (code: string) => {
    const payload = {
      code,
    } as DeleteBillingModel;

    return payload;
  };

  const mapCreateProviderType = (form: ProviderTypeFormSchema) => {
    const payload = {
      name: form.name,
      description: form.description,
      tenant: form.tenant,
    } as CreateProviderTypeModel;

    return payload;
  };
  const mapUpdateProviderType = (
    form: ProviderTypeFormSchema,
    code: string
  ) => {
    const payload = {
      code,
      name: form.name,
      description: form.description,
      tenant: form.tenant,
    } as UpdateProviderTypeModel;

    return payload;
  };
  const mapDeleteProviderType = (code: string) => {
    const payload = {
      code,
    } as DeleteProviderTypeModel;

    return payload;
  };
  const mapCreatePayment = (form: PaymentFormSchema) => {
    const payload = {
      billing: form.billing,
      amount_paid: form.amountPaid,
      status: form.status,
      avatar: form.avatar,
      provider: form.provider,
    } as CreatePaymentModel;

    const newPayload = {
      payment: payload,
      file: form.attachment,
    } as CreatePaymentModelExtension;

    return newPayload;
  };
  const mapUpdatePayment = (form: PaymentFormSchema, code: string) => {
    const payload = {
      code,
      billing: form.billing,
      amount_paid: form.amountPaid,
      status: form.status,
      avatar: form.avatar,
      provider: form.provider,
    } as UpdatePaymentModel;

    const newPayload = {
      payment: payload,
      file: form.attachment,
    } as UpdatePaymentModelExtension;

    return newPayload;
  };
  const mapDeletePayment = (code: string) => {
    const payload = {
      code,
    } as DeletePaymentModel;

    return payload;
  };
  const mapCreateBulkPayment = (form: PaymentFormSchema) => {
    const payload = {
      billing: form.billing,
      amount_paid: form.amountPaid,
      status: form.status,
      avatar: form.avatar,
      provider: form.provider,
      contract: form.contract,
    } as CreateBulkPaymentModel;

    const newPayload = {
      payment: payload,
      file: form.attachment,
    } as CreateBulkPaymentModelExtension;

    return newPayload;
  };
  const mapCreateVisit = (form: VisitFormSchema) => {
    const payload = {
      patient: form.patient,
      contract: form.contract,
      billing: form.billing,
      date: form.date,
      time: form.time,
      description: form.description,
      prescription: form.prescription,
      person: form.person,
      avatar: form.avatar,
    } as CreateVisitModel;

    const newPayload = {
      visit: payload,
    } as CreateVisitModelExtension;

    return newPayload;
  };
  const mapUpdateVisit = (form: VisitFormSchema, code: string) => {
    const payload = {
      code,
      patient: form.patient,
      contract: form.contract,
      billing: form.billing,
      date: form.date,
      time: form.time,
      description: form.description,
      prescription: form.prescription,
      person: form.person,
      avatar: form.avatar,
    } as UpdateVisitModel;

    const newPayload = {
      visit: payload,
    } as UpdateVisitModelExtension;

    return newPayload;
  };
  const mapDeleteVisit = (code: string) => {
    const payload = {
      code,
    } as DeleteVisitModel;

    return payload;
  };
  const mapCreateWaiver = (form: WaiverFormSchema) => {
    const payload = {
      tenant: form.tenant,
      name: form.name,
      description: form.description,
      sub_title: form.subtitle,
      font_size: form.fontSize,
    } as CreateWaiverModel;

    return payload;
  };
  const mapUpdateWaiver = (form: WaiverFormSchema, code: string) => {
    const payload = {
      code,
      tenant: form.tenant,
      name: form.name,
      description: form.description,
      sub_title: form.subtitle,
      font_size: form.fontSize,
    } as UpdateWaiverModel;

    return payload;
  };
  const mapDeleteWaiver = (code: string) => {
    const payload = {
      code,
    } as DeleteWaiverModel;

    return payload;
  };
  const mapCreateRegistration = (form: RegistrationFormSchema) => {
    const payload = {
      tenant: form.tenant,
      first_name: form.firstName,
      middle_name: form.middleName,
      last_name: form.lastName,
      birthday: form.birthday,
      gender: form.gender,
      address: form.address,
      mobile_number: form.mobileNumber,
      avatar: form.avatar,
      email: form.email,
      is_taking_medication: form.isTakingMedication,
      medication_details: form.medicationDetails,
      has_allergies: form.hasAllergies,
      allergy_details: form.allergyDetails,
      has_medical_conditions: form.hasMedicalConditions,
      medical_conditon_details: form.medicalConditonDetails,
      was_recently_unwell: form.wasRecentlyUnwell,
      unwell_details: form.unwellDetails,
      other_medical_conditions: form.otherMedicalConditions,
      service: form.service,
      date: form.date,
      time: form.time,
      other_remarks: form.otherRemarks,
      status: form.status,
    } as CreateRegistrationModel;

    return payload;
  };
  const mapUpdateRegistration = (
    form: RegistrationFormSchema,
    code: string
  ) => {
    const payload = {
      code,
      tenant: form.tenant,
      first_name: form.firstName,
      middle_name: form.middleName,
      last_name: form.lastName,
      birthday: form.birthday,
      gender: form.gender,
      address: form.address,
      mobile_number: form.mobileNumber,
      avatar: form.avatar,
      email: form.email,
      is_taking_medication: form.isTakingMedication,
      medication_details: form.medicationDetails,
      has_allergies: form.hasAllergies,
      allergy_details: form.allergyDetails,
      has_medical_conditions: form.hasMedicalConditions,
      medical_conditon_details: form.medicalConditonDetails,
      was_recently_unwell: form.wasRecentlyUnwell,
      unwell_details: form.unwellDetails,
      other_medical_conditions: form.otherMedicalConditions,
      service: form.service,
      date: form.date,
      time: form.time,
      other_remarks: form.otherRemarks,
      status: form.status,
    } as UpdateRegistrationModel;

    return payload;
  };
  const mapDeleteRegistration = (code: string) => {
    const payload = {
      code,
    } as DeleteRegistrationModel;

    return payload;
  };

  const mapApproveRegistration = (form: ApproveRegistrationFormSchema) => {
    const payload = {
      code: form.code,
      status: form.status,
    } as ApproveRegistrationModel;

    return payload;
  };

  // MAPPER FUNCTION

  return {
    mapLogin,
    mapCreateTenant,
    mapUpdateTenant,
    mapDeleteTenant,
    mapCreateRole,
    mapUpdateRole,
    mapDeleteRole,
    mapCreatePerson,
    mapUpdatePerson,
    mapDeletePerson,
    mapCreatePatient,
    mapUpdatePatient,
    mapDeletePatient,
    mapCreateUtilService,
    mapUpdateUtilService,
    mapDeleteUtilService,
    mapCreateContract,
    mapUpdateContract,
    mapDeleteContract,
    mapCreateBilling,
    mapUpdateBilling,
    mapDeleteBilling,

    mapCreateProviderType,
    mapUpdateProviderType,
    mapDeleteProviderType,
    mapCreatePayment,
    mapUpdatePayment,
    mapDeletePayment,
    mapCreateBulkPayment,
    mapCreateVisit,
    mapUpdateVisit,
    mapDeleteVisit,
    mapCreateWaiver,
    mapUpdateWaiver,
    mapDeleteWaiver,
    mapCreateRegistration,
    mapUpdateRegistration,
    mapDeleteRegistration,
    mapApproveRegistration,
    mapGetPublicUtilService,
    // MAPPER RETURN
  };
}
